import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DigitalAssetsComponent } from './digital-assets.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'digital-assets',
        component: DigitalAssetsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin', 'dam-view', 'dam-edit', 'repository'] },
        resolve: { permissions: PermissionsResolver }
      },
    ])
  ],
  exports: [RouterModule],
})
export class DigitalAssetsRoutingModule {}
